import { Component, ElementRef, Injector, Input, OnInit, Output, ViewChild} from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { ApisService } from '../../services/apis.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { Base} from '../base/base';
@Component({
  selector: 'app-edit-document-user',
  templateUrl: './edit-document-user.component.html',
  styleUrls: ['./edit-document-user.component.css']
})
export class EditDocumentUserComponent extends Base {
  isReject: boolean = false;
  public vehicleForm: FormGroup;
  loading: boolean = false;
  @ViewChild('inputLicenseFront') inputLicenseFront: ElementRef;
  @ViewChild('inputLicenseBack') inputLicenseBack: ElementRef;
  @ViewChild('inputFileIdentifyFront') inputFileIdentifyFront: ElementRef;
  @ViewChild('inputFileIdentifyBack') inputFileIdentifyBack: ElementRef;
  imageLicenseFront = '';
  imageLicenseBack = '';
  imageIdentifyFront = '';
  imageIdentifyBack = '';
  public url_base = this.URL_BASE;
  @Input() public data;
  @Input() public action;

  constructor(injector: Injector,
              private form: FormBuilder,
              private router: Router,
              private NgxSpinner: NgxSpinnerService,
              private apis: ApisService) {
      super(injector);
  }

  ngOnInit() {
    console.log('llego data (this.data, this.action) :: ', this.data, this.action);
  }

  onSubmit() {
    const form = this.vehicleForm.value;
  }



  handleInputChange(image, name) {
    let file = image.target.files[0];
    let context = this;
    var reader: any = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
      switch (name) {
        case 'driving_license_front':
          context.imageLicenseFront = reader.result.split(',')[1];
          break;
        case 'driving_license_back':
          context.imageLicenseBack = reader.result.split(',')[1];
          break;
        case 'identify_front':
          context.imageIdentifyFront = reader.result.split(',')[1];
          break;
        case 'identify_back':
          context.imageIdentifyBack = reader.result.split(',')[1];
          break;
      }
    };
    reader.onerror = function (error) {
      console.log('Error: ', error);
    };
  }

  saveImagen(name) {
    if (this.data && this.data.vehicle_id) {
      let image = '';
      let imageOld = '';
      switch (name) {
        case 'driving_license_front':
          image = this.imageLicenseFront;
          imageOld = this.data.driving_license_front;
          break;
        case 'driving_license_back':
          image = this.imageLicenseBack;
          imageOld = this.data.driving_license_back;
          break;
        case 'identify_front':
          image = this.imageIdentifyFront;
          imageOld = this.data.identify_front;
          break;
        case 'identify_back':
          image = this.imageIdentifyBack;
          imageOld = this.data.identify_back;
          break;
      }
      let data = {
        user_id: this.data.user_id,
        name: name,
        image: image,
        imageOld: imageOld
      };

      this.apis.updateImageDocumentsUser(data).then(result => {
        if (result['status'] == 'success') {
          this.data[name] = result['data'][name];
        }
      });
    }
  }

  resetInputFile(event, name) {
    console.log('reset ', event);
    switch (name) {
      case 'driving_license_front':
        this.inputLicenseFront.nativeElement.value = '';
        break;
      case 'driving_license_back':
        this.inputLicenseBack.nativeElement.value = '';
        break;
      case 'identify_front':
        this.inputFileIdentifyFront.nativeElement.value = '';
        break;
      case 'identify_back':
        this.inputFileIdentifyBack.nativeElement.value = '';
        break;
    }
  }
}
